import { LIST_EXCHANGE_RATE_QUERY_KEY } from '@src/exchangeRateManager/hooks/useExchangeRate';
import { ExchangeRateClient } from '@src/exchangeRateManager/services/ExchangeRateClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface Props {
  onSuccess?: () => void;
}

export const useSetNextExchangeRate = (props: Props) => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation<
    void,
    Error,
    { data: { cadToUsd: number; usdToCad: number } }
  >({
    mutationFn: async ({ data }) => {
      await ExchangeRateClient.setRate(data);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [LIST_EXCHANGE_RATE_QUERY_KEY],
      });
      if (props.onSuccess) {
        props.onSuccess();
      }
    },
  });

  return { setExchangeRate: mutate };
};
